import PropTypes from 'prop-types';
import { getCouponDiscount } from '../../utils/coupon-utils';

export default function CouponSection({ hasCoupon, discount, currentTotal }) {
    if (!hasCoupon || !currentTotal) {
        return null;
    }

    if (discount?.coupon?.valid === false || !discount?.coupon?.id) {
        return null;
    }

    const discountValue =
        '-' +
        getCouponDiscount({ coupon: discount.coupon, currentTotal: currentTotal, format: true });

    // coupon.name as per Stripe
    // If we have a name, we use that, otherwise we use the
    // coupon ID in uppercase
    const trimmedCouponName = discount.coupon?.name?.trim();
    const couponNameSection = trimmedCouponName ? (
        <span>
            <strong>{trimmedCouponName}</strong> discount
        </span>
    ) : (
        <span>
            <strong>
                {typeof discount.coupon.id === 'string' ? discount.coupon.id.toUpperCase() : ''}
            </strong>{' '}
            coupon
        </span>
    );

    return (
        <div className="green highlighted" data-test-id="checkout-coupon">
            {couponNameSection}
            <span>{discountValue}</span>
        </div>
    );
}

CouponSection.propTypes = {
    hasCoupon: PropTypes.bool.isRequired,
    discount: PropTypes.shape({
        coupon: PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string,
            valid: PropTypes.bool,
            percent_off: PropTypes.number,
            amount_off: PropTypes.number,
        }),
    }),
    currentTotal: PropTypes.number,
};
